import TextButton from "../components/atomics/text-button";
import AuthLayout from "../components/layouts/auth-layout";
import { useNavigate } from "react-router-dom";

const List = () => {
    const navigate = useNavigate();

    return (
        <AuthLayout hideBackgroundImg >
            <div>
                <TextButton onClick={() => navigate("/login")} type="link">
                    Giriş Yap
                </TextButton>
            </div>
            <div>
                <TextButton onClick={() => navigate("/signup")} type="link">
                   Kayıt Ol
                </TextButton>
            </div>
            <div>
                <TextButton onClick={() => navigate("/request/create")} type="link">
                   Talep Oluştur
                </TextButton>
            </div>
        </AuthLayout>
    );
};

export default List;
